var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M22.612,13.109l-.007,0L3.029,4.589a1.037,1.037,0,0,0-1.018.1,1.2,1.2,0,0,0-.511.99V11.13a1.141,1.141,0,0,0,.895,1.133l10.677,2.071a.194.194,0,0,1,0,.378L2.4,16.782a1.141,1.141,0,0,0-.9,1.132v5.448a1.149,1.149,0,0,0,.485.947,1.061,1.061,0,0,0,.606.192,1.08,1.08,0,0,0,.436-.093L22.6,15.94l.009,0a1.569,1.569,0,0,0,0-2.827Z",
    transform: "translate(-1.5 -4.501)",
    fill: "#6249ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5a3aacbc9bdb6289ecc98b66b3685c2a.svg";
export { ForwardRef as ReactComponent };